const cookieBox = document.querySelector('.cookies');
const buttons = document.querySelectorAll('.cookies-button');

const executeCodes = () => {
	if (!cookieBox || buttons.length === 0) return;

	// if cookie contains codinglab it will be returned and below of this code will not run
	if (document.cookie.includes('one')) return;
	cookieBox.classList.add('show');

	buttons.forEach(button => {
		button.addEventListener('click', () => {
			cookieBox.classList.remove('show');//eslint-disable-line			
			if (button.id === 'acceptBtn') {
        document.cookie = `acceptBy= one; max-age=${60 * 60 * 24 * 30}`;//eslint-disable-line
      }//eslint-disable-line
      else {//eslint-disable-line

        cookieBox.classList.remove('show');//eslint-disable-line
				const allCookies = document.cookie.split(';');
				for (let i = 0; i < allCookies.length; i++) {//eslint-disable-line
					document.cookie = `${allCookies[i]}='';expires=${new Date(0).toUTCString()}`;
				}
      }//eslint-disable-line
		});
	});
};

// executeCodes function will be called on webpage load
window.addEventListener('load', executeCodes);
